(function () {
  function init_shop_mt_carousel(section) {
    if (section.dataset.shopMtCarouselInit === 'true') return;
    var track = section.querySelector('[data-shop-mt-track]');
    if (!track) return;

    section.dataset.shopMtCarouselInit = 'true';

    var prev = section.querySelector('[data-shop-mt-prev]');
    var next = section.querySelector('[data-shop-mt-next]');

    function step_size() {
      var item = track.querySelector('.shop-mt__item');
      var grid = track.querySelector('.shop-mt__grid');
      if (!item || !grid) return 280;
      var gap = parseFloat(window.getComputedStyle(grid).columnGap || window.getComputedStyle(grid).gap) || 12;
      return item.offsetWidth + gap;
    }

    function update_arrows() {
      var max_scroll = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max_scroll;
    }

    track.addEventListener('scroll', update_arrows, { passive: true });
    window.addEventListener('resize', update_arrows);

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step_size(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step_size(), behavior: 'smooth' });
      });
    }

    update_arrows();
  }

  function boot() {
    document.querySelectorAll('.shop-mt--carousel, .shop-mt--mobile-carousel').forEach(init_shop_mt_carousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.shop-mt--carousel, .shop-mt--mobile-carousel').forEach(init_shop_mt_carousel);
  });
})();
